import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaChevronDown, FaChevronUp, FaEye, FaEyeDropper, FaEyeSlash, FaNewspaper, FaRegArrowAltCircleLeft } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';

const Resultat_examen_admin = ({ titre }) => {
    useAuth();
    const [qcms, setQcms] = useState([]);
    const [examen, setExamen] = useState([]);
    const [data, setData] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showInfo, setShowInfo] = useState(false);
    const [afficherResultats, setAfficherResultats] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const location = useLocation();
    const { examen_id } = location.state || {};
    const { utilisateur_id } = location.state || {};
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Terminer";
        }
    }, [user_id]);


    const [examenblancDetails, setExamenblancDetails] = useState([]);


    // useEffect(() => {
    //     const fetchData = async () => {
    //         setIsLoading(true); // Indiquer le début du chargement

    //         try {
    //             // Récupérer d'abord les détails de l'examen
    //             const examenResponse = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-examenblanc/${examen_id?.id}/${user_id}`);
    //             if (examenResponse.ok) {
    //                 const examenData = await examenResponse.json();
    //                 setExamenblancDetails(examenData);
    //             }
    //         } catch (error) {
    //             console.error('Erreur lors de la récupération des données:', error);
    //         } finally {
    //             setIsLoading(false); // Indiquer la fin du chargement
    //         }
    //     };

    //     fetchData();
    // }, [examen_id, user_id]); // Exécuter seulement si `examen_id` ou `user_id` change



    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            handleFinishExamen()
        }, 3000);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const itemsParPage = 5;


    const totalPages = Math.ceil(qcms.length / itemsParPage);


    const debutIndex = (currentPage - 1) * itemsParPage;
    const finIndex = debutIndex + itemsParPage;
    const currentQcms = qcms.slice(debutIndex, finIndex);


    const pageSuivante = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const pagePrecedente = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleFinishExamen = async () => {
        setIsLoading(true)
        // Logique de terminaison de simulation
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/examen-donnes-resultats/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: user_id,
                    examen_id: examen_id,
                }),
            });
            if (response.ok) {
                setIsLoading(false)
                const data = await response.json();
                console.log(data)
                setData(data);
                setQcms(data.qcms)
            } else {
                setIsLoading(false)
                console.error('Erreur lors de la récupérationnnn');
            }
        } catch (error) {
            setIsLoading(false)
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        handleFinishExamen();
    }, []);

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2><FaNewspaper size={25} className='mr-2' />
                                    {/* {data?.langue === 'Fr' ? 'Resultat Examen Blanc' : 'Exam result'} */}
                                    Resultat Examen Blanc
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>
                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                {/* {data?.langue === 'Fr' ? (
                                    <small>
                                        Résultat et correction de l'examen. Les explications et les éventuelles références au Guide PMBOK aident à mieux comprendre la logique des questions.
                                    </small>
                                ) : (
                                    <small>
                                        Exam results and corrections, along with explanations and possible references to the PMBOK Guide, help provide a better understanding of the logic behind the questions.
                                    </small>
                                )} */}
                                <small>
                                    Résultat et correction de l'examen.
                                </small>

                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Gestion-des-examens`}> Examens</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Resultats de l'examen {examen_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox ">
                                    <div className="ibox-title p-3">
                                        <div className='p-2 d-flex align-items-center justify-content-between'>
                                            <h5>Résultat de l'Examen Blanc</h5>
                                            {/* <h5>{data?.langue === 'Fr' ? "Résultat de l\'Examen Blanc" : "Exam Results"}</h5> */}
                                            <span
                                                className='label label-primary mb-2'
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setAfficherResultats(!afficherResultats)}
                                            >
                                                <span className='mr-2'>Voir corrigé</span>
                                                {afficherResultats ? <FaEye /> : <FaEyeSlash />}
                                            </span>
                                        </div>

                                        {isLoading ? (
                                            <div className="text-center">
                                                <span className="spinner-border text-success" role="status"></span>
                                                <p>Chargement des résultats...</p>
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                {examen ? (
                                                    <table className="table table-striped table-hover">
                                                        <tr>
                                                            {/* <td>{data?.langue === 'Fr' ? "Date et heure" : "Date and Time"}</td> */}
                                                            <td>Date et heure</td>
                                                            <td>{data?.date_examen}</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Niveau" : "Level"}</td> */}
                                                            <td>Niveau</td>
                                                            <td>{data?.type_examen === 2 ? "CAPM" : "PMP"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Heure de Début</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Heure de Début" : "Start Time"}</td> */}
                                                            <td>{data?.heureDebut}</td>
                                                            <td>Heure de Fin</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Heure de Fin" : "End Time"}</td> */}
                                                            <td>{data?.heureFin}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Nombre de Questions</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Nombre de Questions" : "Total Questions"}</td> */}
                                                            <td>{data?.total_questions}</td>
                                                            <td>Questions traitées</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Questions traitées" : "Questions Answered"}</td> */}
                                                            <td>{data?.questions_traitees}/{data?.total_questions}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Pourcentage</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Pourcentage" : "Percent"}</td> */}
                                                            <td>
                                                                <div className="progress m-t-xs full">
                                                                    <div
                                                                        className={`progress-bar ${data?.pourcent < 80 ? 'progress-bar-danger' : 'progress-bar-success'}`}
                                                                        role="progressbar"
                                                                        aria-valuemin="0"
                                                                        aria-valuemax="100"
                                                                        aria-valuenow={data?.pourcent}
                                                                        style={{ width: `${data?.pourcent}%` }}
                                                                    >
                                                                        <span className={data?.pourcent === 0 ? 'text-dark' : ''}>
                                                                            {data?.pourcent}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div style={{ color: data?.pourcent < 80 ? "red" : "green" }}>
                                                                    {data?.pourcent < 80 ? "Echec (< 80%)" : "Réussite (>= 80%)"}
                                                                </div>
                                                            </td>
                                                            <td>Bonnes réponses</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Bonnes réponses" : "Corrects Answers"}</td> */}
                                                            <td>{data?.nombre_correct}/{data?.total_questions}</td>
                                                        </tr>
                                                    </table>
                                                ) : null}
                                            </div>
                                        )}

                                    </div>
                                    <div className="ibox-content">
                                        <div>
                                            {
                                                afficherResultats && (
                                                    <div className={`${afficherResultats ? "open" : ""}`}>
                                                        {currentQcms.length > 0 ? (
                                                            currentQcms.map((qcm) => (
                                                                <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px', fontSize: '12px' }}>
                                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />

                                                                    <div>
                                                                        <span># {qcm.ref} - </span>
                                                                        <span id="question" style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                                    </div>

                                                                    <div style={{ margin: '10px 10px' }}>
                                                                        {Object.keys(qcm)
                                                                            .filter((key) => key.startsWith('option') && qcm[key] && qcm[key] !== 'non défini')
                                                                            .map((key, index) => {
                                                                                const optionLetter = String.fromCharCode(65 + index); // Générer A, B, C, ...
                                                                                const optionText = qcm[key]; // Texte de l'option
                                                                                const isCorrect = Array.isArray(qcm.reponse) && qcm.reponse.includes(optionLetter);
                                                                                const isSelected = Array.isArray(qcm.choix) && qcm.choix.includes(optionLetter);

                                                                                return (
                                                                                    <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '12px' }}>
                                                                                        <span style={{ marginRight: '10px' }}>
                                                                                            {optionLetter} - {optionText}
                                                                                        </span>

                                                                                        {/* Gestion des icônes selon les réponses et sélections */}
                                                                                        {isCorrect && isSelected ? (
                                                                                            <i className="fa fa-thumbs-up fa-2x" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer (Selected)"></i>
                                                                                        ) : isCorrect ? (
                                                                                            <i className="fa fa-thumbs-up fa-2x" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer"></i>
                                                                                        ) : isSelected ? (
                                                                                            <i className="fa fa-thumbs-down fa-2x" style={{ color: 'red', marginLeft: '5px' }} title="Incorrect Answer (Selected)"></i>
                                                                                        ) : null}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                    </div>

                                                                    <div style={{ marginTop: '10px', fontStyle: 'italic', color: 'blue' }}>
                                                                        <p>{data?.langue === 'Fr' ? "Bonnes réponses : " : "Corrects answers : "}{qcm.reponse.join(' , ')}</p>
                                                                    </div>

                                                                    {qcm.explication && qcm.explication !== 'non défini' && (
                                                                        <div style={{ color: 'green' }}>
                                                                            <span>Explication : </span>
                                                                            <span id="explication" style={{ fontSize: '12px', color: 'green', marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>Aucun QCM avec résultat trouvé pour cet examen.</p>
                                                        )}

                                                        {/* Pagination controls */}
                                                        {totalPages > 1 && (
                                                            <div className="d-flex justify-content-between mt-4 mb-4">
                                                                <Button
                                                                    className="btn btn-success"
                                                                    disabled={currentPage === 1}
                                                                    onClick={pagePrecedente}
                                                                >
                                                                    <FaArrowAltCircleLeft />
                                                                </Button>
                                                                <span>Page {currentPage} sur {totalPages}</span>
                                                                <Button
                                                                    className="btn btn-success"
                                                                    disabled={currentPage === totalPages}
                                                                    onClick={pageSuivante}
                                                                >
                                                                    <FaArrowAltCircleRight />
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <Button
                                                className='btn btn-success d-flex align-items-center justify-between'
                                                onClick={() => navigate('/Gestion-des-examens')}
                                            >
                                                <FaRegArrowAltCircleLeft className='mr-1' /> Retour à la liste des examens
                                                {/* <FaRegArrowAltCircleLeft className='mr-1' /> {data?.langue === 'Fr' ? "Retour à la liste des examens" : "Return to exam list"} */}
                                            </Button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Resultat_examen_admin;
